import * as _ from "lodash-es";
import React, { useContext, useEffect, useState } from "react";
import "./OrderEntryFloatingSubmit.scss";
import IOrderUI from "../../../models/IOrderUI";
import OwButton from "../../shared/OwButton/OwButton";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import ISubmitOrderDTO from "../../../models/DTO/ISubmitOrderDTO";
import { NumericFormat } from "react-number-format";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import UiContext from "../../../contexts/UiContext";
import { useSubmitOrderFlow } from "../../../hooks/order_entry/useSubmitOrderFlow";
import { useOrderButtonLogic } from "../../../hooks/order_entry/useOrderStepButtonsLogic";

type Props = {
    submitFn: (payload: ISubmitOrderDTO) => void;
    order: IOrderUI;
    hasPendingDetailChanges: boolean;
    btnActive: boolean;
    hasEditMode: boolean;
    isFineDetailsValid: boolean;
    hasPendingFineDetailChanges: boolean;
    hasRowsInEditMode: boolean;
    convertQuoteToOrderActive: boolean;
    hideSubmitBtn?: boolean;
};

export const OrderEntryFloatingSubmit: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const uiContext = useContext(UiContext);

    const [isSideBarOpen, setIsSideBarOpen] = useState(uiContext.getSidebarState());
    const [isVisible, setIsVisible] = useState(true);
    const [menuState, setMenuState] = useState({
        isMenuOpen: uiContext.isMenuOpen(),
        isMenuIconMode: uiContext.isMenuIconMode(),
        lookupWidth: "",
        lookupLeft: "",
    });

    useEffect(() => {
        const { lookupWidth, lookupLeft } = getLookupSize(uiContext.isMenuOpen(), uiContext.isMenuIconMode());

        setMenuState({ isMenuOpen: uiContext.isMenuOpen(), isMenuIconMode: uiContext.isMenuIconMode(), lookupWidth, lookupLeft });
    }, [uiContext.menuIconMode, uiContext.menuOpen]);

    const sideBarOpen = uiContext.getSidebarState();

    useEffect(() => {
        setIsSideBarOpen(sideBarOpen);
    }, [sideBarOpen]);

    const toggleVisible = () => {
        setIsVisible(!isVisible);
    };

    const getLookupSize = (isMenuOpen?: boolean, isMenuIconMode?: boolean) => {
        let lookupWidth = "100%";
        let lookupLeft = "0px";

        if (_.isNil(isMenuOpen)) {
            isMenuOpen = menuState.isMenuOpen;
        }

        if (_.isNil(isMenuIconMode)) {
            isMenuIconMode = menuState.isMenuIconMode;
        }

        const mainView = document.getElementById("mainView");

        if (mainView && (isMenuOpen || isMenuIconMode)) {
            const padding = 0;
            lookupWidth = `${mainView.offsetWidth}px`;
            lookupLeft = `${mainView.offsetLeft + padding}px`;
        }

        return { lookupWidth, lookupLeft };
    };

    const buttonLogic = useOrderButtonLogic(
        props.order,
        supplierModel,
        userModel,
        props.hasEditMode,
        props.hasPendingDetailChanges,
        props.hasPendingFineDetailChanges,
        props.isFineDetailsValid,
        props.hasRowsInEditMode
    );

    const { performSubmit } = useSubmitOrderFlow(props.submitFn, props.order);

    let stepButtonDisabledReason: any | null = <div>&nbsp;</div>;

    if (buttonLogic.stepButtonDisabled && buttonLogic.stepButtonDisabledReason) {
        stepButtonDisabledReason = <OwTranslate defaultMessage={"Pending Changes"} id={buttonLogic.stepButtonDisabledReason} />;
    }

    if (buttonLogic.creditLimitReason) {
        stepButtonDisabledReason = (
            <OwTranslate
                defaultMessage={"Not Enough Available Credit: {amount}"}
                id={"not_enough_available_credit"}
                values={{
                    amount: (
                        <NumericFormat
                            value={buttonLogic.creditLimitReason.availableBalance}
                            prefix={"$"}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            thousandSeparator={true}
                            displayType={"text"}
                        />
                    ),
                }}
            />
        );
    }

    const elem =
        buttonLogic.nextStep && buttonLogic.allowSubmit && !props.order.is_on_hold ? (
            <div className={"OrderEntryFloatingSubmit"}>
                <div
                    className={(isSideBarOpen ? "sideBarOpen" : "") + " FloatingBar " + (isVisible ? "" : "hide-bar")}
                    style={{ width: menuState.lookupWidth }}>
                    {props.hideSubmitBtn ? null : (
                        <div className={"toggle-row"}>
                            <i className={"fas " + (isVisible ? "fa-chevron-down" : "fa-chevron-up")} onClick={toggleVisible} />
                        </div>
                    )}
                    {buttonLogic.stepButtonDisabled || buttonLogic.creditLimitReason ? (
                        <div className={"text-danger text-center feedback-row"}>{stepButtonDisabledReason}</div>
                    ) : null}

                    <div className={"text-white text-center"}>
                        {props.order?.Vendor?.name} - {props.order.name}
                    </div>

                    {props.hideSubmitBtn || props.order.is_quote || props.order.is_template ? null : (
                        <div className={"d-flex justify-content-center align-items-center mt-2 button-row"}>
                            <OwButton
                                btnSizeClass={"btn-sm"}
                                className={"btn btn-warning"}
                                title={"submit"}
                                leftIconClass={"fas fa-arrow-circle-right"}
                                disabled={buttonLogic.isButtonDisabled || buttonLogic.stepButtonDisabled || props.convertQuoteToOrderActive}
                                fn={() => {
                                    performSubmit(buttonLogic.nextStep);
                                }}
                                active={props.btnActive}
                            />
                        </div>
                    )}
                </div>
            </div>
        ) : null;

    return elem;
};
